// extracted by mini-css-extract-plugin
export default {"range_value":"Input_range_value__dDX4A","range_wrap":"Input_range_wrap__fJfHS"};